<template>
	<div>
		<el-steps :active="actives" simple>
			<el-step icon="el-icon-upload" title="上传代理委托书"></el-step>
			<el-step icon="el-icon-edit" title="作品创作信息"></el-step>
			<el-step icon="el-icon-edit" title="作品权属信息"></el-step>
			<el-step icon="el-icon-edit" title="确认信息"></el-step>
			<el-step icon="el-icon-edit" title="提交成功"></el-step>
		</el-steps>
	</div>
</template>

<script>
	export default {
		name: 'copyrighthead',
		props: {
			actives: {
				type: [Number, String],
				default: 0
			}
		},
		data() {
			return {}

		},
		created() {},
		updated() {},
		methods: {

		}
	}
</script>
<style lang="scss" scoped>
	/deep/ .el-step.is-simple .el-step__arrow::before,
	/deep/ .el-step.is-simple .el-step__arrow::after {
		height: 8px;
	}

	/deep/ .el-step.is-simple .el-step__arrow::after {
		transform: rotate(45deg) translateY(2px);
	}

	/deep/ .el-step.is-simple .el-step__arrow::before {
		transform: rotate(-45deg) translateY(-2px);
	}

	/deep/ .el-step.is-simple .el-step__title {
		max-width: 100%;
		font-size: 14px;
	}
	/deep/ .el-steps--simple{
		padding: 14px 5%;
	}
</style>
